import { initAnchorNavigation } from "modules/AnchorNavigation";

(function (): void {
    // Initialize anchor navigation for AboutUsCountryTemplate
    initAnchorNavigation(".js-about-us-country-template");
})();
